import React from 'react'
import EditorHelper from 'components/contentEditor/EditorHelper'
import Utils from 'utils/Utils'

export default class Button extends React.Component {

    render() {

        const {item, defaults, style, innerRef, ...props} = this.props;

        return (
            <span
                ref={innerRef}
                style={Object.assign(style,{
                    paddingLeft: EditorHelper.getMargin(item, defaults, "left") * this.props.scale,
                    paddingRight: EditorHelper.getMargin(item, defaults, "right") * this.props.scale,
                    paddingBottom: EditorHelper.getMargin(item, defaults, "bottom") * this.props.scale,
                    paddingTop: EditorHelper.getMargin(item, defaults, "top") * this.props.scale,
                    display: "block"
                })}

                {...props}
            >
                <span
                    style={{
                        fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
                        fontSize: 20 * this.props.scale,
                        color: "#575757",
                        height: 150 * this.props.scale,
                        paddingTop: 12 * this.props.scale,
                        textAlign: "left",
                        borderRadius: 15 * this.props.scale,
                        border: "1px solid #575757",
                        lineHeight: "normal",
                        display: "block"
                    }}
                >
                </span>
            </span>
        )
    }

}